import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-cardSlider';
	$(base, context).each(function(i, el){
		setTimeout(function() {
			new Swiper (el.querySelector('.b-cardSlider-container'), {
				slidesPerView: 'auto',
				spaceBetween: 16,
				slideClass: 'b-card',
				navigation : {
					nextEl : el.querySelector('.b-sliderArrows-btn_next'),
					prevEl : el.querySelector('.b-sliderArrows-btn_prev')
				},
				breakpoints: {
					1024: {
						slidesPerView: 3,
					},
					1380: {
						slidesPerView: 3,
						spaceBetween: 40,
					},
				},
			});
		});
	});
});
